import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Select, TimePicker } from "antd";
import { API_CREATE_LAUNDRY_MEN } from "api/laundry-management";
import moment from "moment";
import { API_UPLOAD_CNIC_LAUNDRY_MEN } from "api/laundry-management";
import { API_UPLOAD_LICENSE_LAUNDRY_MEN } from "api/laundry-management";
import { API_LIST_STORE } from "api/store-managemnt";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { CONSTANTS } from "config/constant";
import { API_UPLOAD_PROFILE_PIC_LAUNDRY_MEN } from "api/laundry-management";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import dayjs from "dayjs";

import ReactDatePicker from "react-datepicker";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
const { Option } = Select;

const CreateLaundryMan = () => {
  const Navigate = useNavigate();

  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedTimes, setSelectedTimes] = useState({});
  const [data, setData] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState("");
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [drivertype, setDriverType] = useState("");
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });
  const [fileList, setFileList] = useState([
    // {
    //   uid: "-1",
    //   name: "image.png",
    //   status: "done",
    //   url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    // },
  ]);
  const cnic_front_ref = useRef(null);
  const cnic_back_ref = useRef(null);
  const license_front_ref = useRef(null);
  const license_back_ref = useRef(null);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChanges = ({ fileList: newFileList }) => setFileList(newFileList);
  console.log(fileList, "34313413543");
  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      // Create a FormData object
      const formData = new FormData();
      formData.append("images", file);
      const response = await API_UPLOAD_PROFILE_PIC_LAUNDRY_MEN(formData);

      console.log("result12313", response, file);
      // Handle success
      const newFileList = [
        {
          uid: response.id, // Replace with the unique ID you receive from the server
          name: response?.file?.[0]?.name,
          status: "done",
          url: CONSTANTS?.BACKEND_URL + response?.file?.[0]?.file_url, // Replace with the URL of the uploaded image
        },
      ];

      console.log(newFileList, "iamfilelist");
      setFileList(newFileList);
      setImage(response?.file?.[0]);
      onSuccess();
      toast.success(response?.message);

      console.log("result", response);
      console.log("newFileList", newFileList);
    } catch (error) {
      toast.error(error?.message);
      // Handle exceptions and errors
      console.log("error", error);
      onError(error);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("Upload")}
      </div>
    </button>
  );

  //<<<<<<<<<<<<<<<<<<----------------------- OLD ----------------------->>>>>>>>>>>>

  // // Function to handle day selection
  // const handleDaySelect = (days) => {
  //   setSelectedDays(days);
  //   const updatedTimes = {};
  //   days.forEach((day) => {
  //     if (!selectedTimes[day]) {
  //       updatedTimes[day] = { start: null, end: null };
  //     } else {
  //       updatedTimes[day] = selectedTimes[day];
  //     }
  //   });
  //   console.log("updatedTimes", updatedTimes);
  //   setSelectedTimes(updatedTimes);
  // };
  // // Function to handle start time selection for a specific day
  // const handleStartTimeSelect = (day, time) => {
  //   const updatedTimes = { ...selectedTimes };
  //   updatedTimes[day].start = time;
  //   console.log("updatedTimes==>", updatedTimes);

  //   setSelectedTimes(updatedTimes);
  // };

  // // Function to handle end time selection for a specific day
  // const handleEndTimeSelect = (day, time) => {
  //   const updatedTimes = { ...selectedTimes };
  //   updatedTimes[day].end = time;
  //   setSelectedTimes(updatedTimes);
  // };
  //<<<<<<<<<<<<<<<<<<----------------------- New ----------------------->>>>>>>>>>>>

  // Function to handle day selection
  const handleDaySelect = (days) => {
    setSelectedDays(days);
    const updatedTimes = {};
    days?.forEach((day) => {
      if (!selectedTimes[day]) {
        updatedTimes[day] = { start: null, end: null };
      } else {
        updatedTimes[day] = selectedTimes[day];
      }
    });
    setSelectedTimes(updatedTimes);
  };

  // Function to handle start time selection for a specific day
  const handleStartTimeSelect = (day, time) => {
    console.log(time, "Selected time:");
    setSelectedTimes((prevTimes) => ({
      ...prevTimes,
      [day]: {
        ...prevTimes[day],
        start: time ? time : null,
      },
    }));
    // console.log("Selected time:", time ? time.format("HH:mm") : null);
    // const updatedTimes = { ...selectedTimes };
    // updatedTimes[day] = { ...updatedTimes[day], start: time?.format("HH:mm") }; // Format the moment object
    // setSelectedTimes(updatedTimes);
  };

  const [selectedTime, setSelectedTime] = useState(null);

  const handleTimeChange = (time) => {
    setSelectedTime(time);
  };

  const handleSaveTime = () => {
    if (selectedTime) {
      // Perform save operation here (e.g., update backend or state)
      console.log("Selected Time:", selectedTime.format("HH:mm:ss"));
      // You can update the time in your application state or perform other actions
    }
  };

  // Function to handle end time selection for a specific day
  const handleEndTimeSelect = (day, time) => {
    // const updatedTimes = { ...selectedTimes };
    // updatedTimes[day] = { ...updatedTimes[day], end: time?.format("HH:mm") }; // Format the moment object
    // setSelectedTimes(updatedTimes);
    setSelectedTimes((prevTimes) => ({
      ...prevTimes,
      [day]: {
        ...prevTimes[day],
        end: time ? time : null,
      },
    }));
  };

  // Function to upload CNIC images
  const uploadCNICImagesFront = async (imageFile, imageType, setFieldValue) => {
    try {
      const formData = new FormData();
      formData.append("images", imageFile);
      const response = await API_UPLOAD_CNIC_LAUNDRY_MEN(formData);
      console.log("CNIC image uploaded successfully:", response);
      setFieldValue("cnic_front_image", [response?.file?.[0]]);

      toast.success(response?.message);
    } catch (error) {
      console.error("Error uploading CNIC image:", error);
      toast.error("Error uploading CNIC image");
    }
  };
  // Function to Licence CNIC images
  const uploadLicenceImagesFront = async (
    imageFile,
    imageType,
    setFieldValue
  ) => {
    try {
      const formData = new FormData();
      formData.append("images", imageFile);
      const response = await API_UPLOAD_LICENSE_LAUNDRY_MEN(formData);
      setFieldValue("license_front_image", [response?.file?.[0]]);
      console.log("CNIC image uploaded successfully:", response);
      toast.success(response?.message);
    } catch (error) {
      console.error("Error uploading CNIC image:", error);
      toast.error("Error uploading CNIC image");
    }
  };

  const uploadCNICImagesBack = async (imageFile, imageType, setFieldValue) => {
    try {
      const formData = new FormData();
      formData.append("images", imageFile);
      const response = await API_UPLOAD_CNIC_LAUNDRY_MEN(formData);
      console.log("CNIC image uploaded successfully:", response);
      setFieldValue("cnic_back_image", [response?.file?.[0]]);

      toast.success(response?.message);
    } catch (error) {
      console.error("Error uploading CNIC image:", error);
      toast.error("Error uploading CNIC image");
    }
  };
  // Function to Licence CNIC images
  const uploadLicenceImagesBack = async (
    imageFile,
    imageType,
    setFieldValue
  ) => {
    try {
      const formData = new FormData();
      formData.append("images", imageFile);
      const response = await API_UPLOAD_LICENSE_LAUNDRY_MEN(formData);
      setFieldValue("license_back_image", [response?.file?.[0]]);
      console.log("CNIC image uploaded successfully:", response);
      toast.success(response?.message);
    } catch (error) {
      console.error("Error uploading CNIC image:", error);
      toast.error("Error uploading CNIC image");
    }
  };

  // const fetchData = async () => {
  //   try {
  //     const params = {};
  //     const newData = await API_LIST_STORE(params);
  //     console.log("provider", newData);
  //     setData(newData?.providers);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);
  const fetchData = async (page) => {
    try {
      setLoading(true);
      const params = {
        page: page,
        limit: pagination.pageSize,
        name: "",
      };
      const newData = await API_LIST_STORE(params);
      setData((prevData) => [...prevData, ...newData.providers]);
      setPagination((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.total_pages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.current);
  }, [pagination.current]);

  const handleScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (pagination.current < pagination.totalPages) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };

  console.log("data >>", data);
  console.log("selcted time", selectedTimes, selectedDays);
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              email: "",
              password: "",
              confrirm_password: "",
              phone_number: "",
              // provider: "",
              cnic_front_image: [],
              cnic_back_image: [],
              license_front_image: [],
              license_back_image: [],
              vehicle_number: "",
              vehicle_type: "",
              pickup_order_rate: "",
              delivery_order_rate: "",
              dispatch_order_rate: "",
              availability: [],
              driving_license_number: "",
              laundry_man_type: "",
              pickup_order_rate_from_laundrybox: "",
              pickup_order_rate_from_laundry_to_store: "",
              pickup_order_rate_from_store_to_laundry: "",
              // order_rate_from_store_to_laundry:'',
            }}
            validationSchema={Yup.object({
              first_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              last_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              email: Yup.string()
                .email("Invalid email format")
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .test("valid-domain", "Invalid email format", function (value) {
                  if (!value) return true; // Skip if empty
                  const domain = value.split("@")[1]; // Extract domain part
                  return !!domain && /\./.test(domain); // Check for dot in domain part
                })
                .max(40, "Maximum character long before @")
                .required("Required"),
              password: Yup.string().required("Required"),
              confrirm_password: Yup.string()
                .required("Required")
                .oneOf([Yup.ref("password"), null], "Passwords must match"),

              phone_number: Yup.string()
                .required("Required")
                .length(12, "please enter correct Phone number"),
              // provider: Yup.string().required("Required"),
              cnic_front_image: Yup.array().min(1, "Required"),
              cnic_back_image: Yup.array().min(1, "Required"),
              license_front_image: Yup.array().min(1, "Required"),
              license_back_image: Yup.array().min(1, "Required"),
              vehicle_number: Yup.string().required("Required"),
              vehicle_type: Yup.string().required("Required"),
              pickup_order_rate: Yup.number().required("Required"),
              delivery_order_rate: Yup.number().required("Required"),
              // dispatch_order_rate: Yup.number().required("Required"),
              driving_license_number: Yup.string().required("Required"),
              laundry_man_type: Yup.string().required("Required"),

              // pickup_order_rate_from_store_to_laundry:
              //   Yup.number().required("Required"), // Always required
              // pickup_order_rate_from_laundry_to_store:
              //   Yup.number().required("Required"), // Always required
              pickup_order_rate_from_laundrybox:
                Yup.number().required("Required"),
              // availability: Yup.array()
              //   .min(1, "Please select at least one day")
              //   .required("Please select at least one day"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              console.log("values", values);
              try {
                // Format availability data for payload
                // const formattedAvailability = Object.keys(selectedTimes).map(
                //   (day) => ({
                //     day,
                //     start_time: selectedTimes[day].start
                //       ? selectedTimes[day].start.format("hh:mm A")
                //       : "",
                //     end_time: selectedTimes[day].end
                //       ? selectedTimes[day].end.format("hh:mm A")
                //       : "",
                //   })
                // );
                if (values.laundry_man_type === "truck_driver") {
                  // Check if pickup_order_rate_from_store_to_laundry is provided
                  if (!values.pickup_order_rate_from_store_to_laundry) {
                    setFieldError(
                      "pickup_order_rate_from_store_to_laundry",
                      "Required"
                    );
                    // return;
                  }
                  // else {
                  // delete values.pickup_order_rate_from_store_to_laundry;
                  // }
                  // Check if pickup_order_rate_from_laundry_to_store is provided
                  if (!values.pickup_order_rate_from_laundry_to_store) {
                    setFieldError(
                      "pickup_order_rate_from_laundry_to_store",
                      "Required"
                    );
                    // return;
                  }
                  // Delete unnecessary keys
                  // else {
                  //   delete values.pickup_order_rate_from_laundry_to_store;
                  // }
                } else {
                  delete values.pickup_order_rate_from_store_to_laundry;
                  delete values.pickup_order_rate_from_laundry_to_store;
                }
                const formattedAvailability = Object.keys(selectedTimes).map(
                  (day) => {
                    let startUnix = "";
                    let endUnix = "";

                    // Check if selectedTimes[day].start and selectedTimes[day].end are defined and are moment objects
                    if (
                      selectedTimes[day]?.start &&
                      selectedTimes[day]?.start.unix
                    ) {
                      startUnix = selectedTimes[day].start.unix();
                    }
                    if (
                      selectedTimes[day]?.end &&
                      selectedTimes[day]?.end.unix
                    ) {
                      endUnix = selectedTimes[day].end.unix();
                    }

                    return {
                      day,
                      start_time: startUnix,
                      end_time: endUnix,
                    };
                  }
                );

                // const formattedAvailability = Object.keys(selectedTimes).map(
                //   (day) => {
                //     const startUnix = selectedTimes[day].start
                //       ? selectedTimes[day].start.unix()
                //       : "";
                //     const endUnix = selectedTimes[day].end
                //       ? selectedTimes[day].end.unix()
                //       : "";

                //     return {
                //       day,
                //       start_time: startUnix,
                //       end_time: endUnix,
                //     };
                //   }
                // );

                // Merge formatted availability into form values
                const payload = {
                  ...values,
                  availability: formattedAvailability,
                  profile_image: [image],
                };

                // Call API with payload
                // if (image) {
                const userData = await API_CREATE_LAUNDRY_MEN(payload);
                toast.success(userData?.message);
                Navigate("/admin/laundryman-management/laundryman-tables");
                // }
                //  else {
                //   toast.error("Please Upload Profile Image First");
                // }
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({
              isSubmitting,
              errors,
              values,
              setFieldValue,
              handleChange,
            }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div className="mb-3 flex justify-center">
                  {console.log("values of driver", values, errors)}
                  <Upload
                    action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                    listType="picture-circle"
                    customRequest={customRequest}
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChanges}
                  >
                    {fileList.length == 1 ? null : uploadButton}
                  </Upload>
                  {previewImage && (
                    <Image
                      wrapperStyle={{
                        display: "none",
                      }}
                      preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                          !visible && setPreviewImage(""),
                      }}
                      src={previewImage}
                    />
                  )}
                </div>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("First Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("First Name")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="first_name"
                        placeholder={t("First Name")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="first_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Last Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Last Name")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="last_name"
                        placeholder={t("Last Name")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="last_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Email")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Email")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="email"
                        placeholder={t("Email")}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="relative mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Password")}
                        <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder={t("Password")}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                        className="absolute bottom-[-20px] right-4 top-3"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </button>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    {/* <label className="font-semibold">
                        {" "}
                        {t("Provider")}
                        <span className="text-[red]">*</span>
                      </label> */}
                    {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Provider")}
                      </label> */}
                    {/* <Select
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        name="provider"
                        placeholder={t("Provider")}
                        value={values.provider} // Display selected store_name
                        onChange={(value) => {
                          const selectedOption = data.find(
                            (option) => option._id === value
                          );
                          setFieldValue("provider", value);
                          console.log(
                            "Selected store_name:",
                            selectedOption?.store_name,
                            value
                          );
                        }}
                        style={{ width: "100%" }}
                      >
                        {data.map((option) => (
                          <Option key={option._id} value={option._id}>
                            {option.store_name}
                          </Option>
                        ))}
                      </Select> */}
                    {/* <Field name="provider">
                        {({ field }) => (
                          <Select
                            className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                            // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                            {...field}
                            showSearch
                            placeholder="Select Store"
                            optionFilterProp="children"
                            onPopupScroll={handleScroll}
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            loading={loading}
                            onChange={(value) => {
                              setFieldValue("provider", value);
                              // setTouched({ provider: true });
                            }}
                          >
                            {data.map((item) => (
                              <Option key={item._id} value={item._id}>
                                {item.store_name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Field> */}
                    {/* <ErrorMessage
                        name="provider"
                        component="div"
                        className="text-red-500"
                      /> */}
                    <div className="relative mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Confirm Password")}
                        <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type={showPassword ? "text" : "password"}
                        name="confrirm_password"
                        placeholder={t("Password")}
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                        className="absolute bottom-[-20px] right-4 top-3"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </button>
                      <ErrorMessage
                        name="confrirm_password"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Phone No")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Phone No")}
                      </label> */}
                      {/* 
                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="number"
                        name="phone_number"
                        placeholder={t("Phone No")}
                      /> */}
                      <PhoneInput
                        country={"sa"}
                        disableDropdown={true}
                        onlyCountries={["sa"]}
                        countryCodeEditable={false}
                        autoFormat={true}
                        enableLongNumbers={false}
                        // className="w-100 mt-2"
                        inputProps={{
                          className:
                            "bg-transparent pl-[3rem] peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500",

                          name: "phone_number",
                          placeholder: "Phone No",
                          onKeyPress: (e) => {
                            const currentValue = values?.phone_number || "";
                            const digitsOnly = currentValue?.replace(/\D/g, ""); // Remove non-numeric characters

                            // Prevent input if there are already 12 digits
                            if (digitsOnly?.length >= 12 && /\d/?.test(e.key)) {
                              e.preventDefault();
                            }
                          },
                        }}
                        value={values?.phone_number}
                        onChange={(value) => {
                          setFieldValue("phone_number", value);
                        }}
                      />
                      <ErrorMessage
                        name="phone_number"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("CNIC Front Image")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("CNIC Front Image")}
                      </label> */}
                      {/* <input
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="file"
                        name="cnic_front_image"
                        onChange={(event) => {
                          setFieldValue(
                            "cnic_front_image",
                            event.currentTarget.files[0]
                          );
                          uploadCNICImagesFront(
                            event.currentTarget.files[0],
                            "cnic_front",
                            setFieldValue
                          );
                        }}
                      /> */}
                      <input
                        className=" bg-transparent peer  hidden w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        // className="hidden"
                        type="file"
                        name="cnic_front_image"
                        onChange={(event) => {
                          setFieldValue(
                            "cnic_front_image",
                            event.currentTarget.files[0]
                          );
                          uploadCNICImagesFront(
                            event.currentTarget.files[0],
                            "cnic_front",
                            setFieldValue
                          );
                        }}
                        ref={cnic_front_ref}
                      />
                      <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => cnic_front_ref.current.click()}
                      >
                        {values?.cnic_front_image?.length > 0
                          ? `Image.${values?.cnic_front_image?.[0]?.file_type}`
                          : t("CNIC Front Image")}
                      </div>
                      <ErrorMessage
                        name="cnic_front_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("CNIC Back Image")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("CNIC Back Image")}
                      </label> */}
                      <input
                        // className="hidden"
                        className=" bg-transparent peer  hidden w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="file"
                        name="cnic_back_image"
                        onChange={(event) => {
                          setFieldValue(
                            "cnic_back_image",
                            event.currentTarget.files[0]
                          );
                          uploadCNICImagesBack(
                            event.currentTarget.files[0],
                            "cnic_back_image",
                            setFieldValue
                          );
                        }}
                        ref={cnic_back_ref}
                      />

                      <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => cnic_back_ref.current.click()}
                      >
                        {values?.cnic_back_image?.length > 0
                          ? `Image.${values?.cnic_back_image?.[0]?.file_type}`
                          : t("CNIC Back Image")}{" "}
                      </div>
                      {/* <input
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="file"
                        name="cnic_back_image"
                        onChange={(event) => {
                          setFieldValue(
                            "cnic_back_image",
                            event.currentTarget.files[0]
                          );
                          uploadCNICImagesBack(
                            event.currentTarget.files[0],
                            "cnic_back",
                            setFieldValue
                          );
                        }}
                      /> */}

                      <ErrorMessage
                        name="cnic_back_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("License Front Image")}
                      </label> */}
                      <label className="font-semibold">
                        {" "}
                        {t("License Front Image")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <input
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="file"
                        name="license_front_image"
                        onChange={(event) => {
                          setFieldValue(
                            "license_front_image",
                            event.currentTarget.files[0]
                          );
                          uploadLicenceImagesFront(
                            event.currentTarget.files[0],
                            "license_front",
                            setFieldValue
                          );
                        }}
                      /> */}
                      <input
                        className=" bg-transparent peer  hidden w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        // className="hidden"
                        type="file"
                        name="license_front_image"
                        onChange={(event) => {
                          setFieldValue(
                            "license_front_image",
                            event.currentTarget.files[0]
                          );
                          uploadLicenceImagesFront(
                            event.currentTarget.files[0],
                            "license_front_image",
                            setFieldValue
                          );
                        }}
                        ref={license_front_ref}
                      />
                      <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => license_front_ref.current.click()}
                      >
                        {values?.license_front_image?.length > 0
                          ? `Image.${values?.license_front_image?.[0]?.file_type}`
                          : t("License Front Image")}{" "}
                      </div>
                      <ErrorMessage
                        name="license_front_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("License Back Image")}{" "}
                      </label> */}
                      <label className="font-semibold">
                        {" "}
                        {t("License Back Image")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <input
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="file"
                        name="license_back_image"
                        onChange={(event) => {
                          setFieldValue(
                            "license_back_image",
                            event.currentTarget.files[0]
                          );
                          uploadLicenceImagesBack(
                            event.currentTarget.files[0],
                            "license_back",
                            setFieldValue
                          );
                        }}
                      /> */}
                      <input
                        // className="hidden"
                        className=" bg-transparent peer  hidden w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="file"
                        name="license_back_image"
                        onChange={(event) => {
                          setFieldValue(
                            "license_back_image",
                            event.currentTarget.files[0]
                          );
                          uploadLicenceImagesBack(
                            event.currentTarget.files[0],
                            "license_back_image",
                            setFieldValue
                          );
                        }}
                        ref={license_back_ref}
                      />
                      <div
                        className="mt-2 flex h-11 w-full cursor-pointer items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        onClick={() => license_back_ref.current.click()}
                      >
                        {values?.license_back_image?.length > 0
                          ? `Image.${values?.license_back_image?.[0]?.file_type}`
                          : t("License Back Image")}
                      </div>
                      <ErrorMessage
                        name="license_back_image"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Vehicle Number")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Vehicle Number")}{" "}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="vehicle_number"
                        placeholder={t("Vehicle Number")}
                      />
                      <ErrorMessage
                        name="vehicle_number"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Vehicle Type")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Vehicle Type")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="vehicle_type"
                        placeholder={t("Vehicle Type")}
                      />
                      <ErrorMessage
                        name="vehicle_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Driver Type")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Driver Type")}
                      </label> */}
                      <Field
                        as="select" // Use 'as' prop to render a select box
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        name="laundry_man_type"
                        onChange={(e) => {
                          setDriverType(e.target.value);
                          setFieldValue("laundry_man_type", e.target.value);
                        }}
                        value={drivertype}
                      >
                        <option value="" disabled>
                          {t("Select Driver Type")}
                        </option>{" "}
                        <option value="car_driver">{t("Car")}</option>{" "}
                        {/* Option for car */}
                        <option value="truck_driver">{t("Truck")}</option>{" "}
                        {/* Option for truck */}
                      </Field>
                      <ErrorMessage
                        name="laundry_man_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Pickup Order Rate")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Pickup Order Rate")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="pickup_order_rate"
                        placeholder={t("Pickup Order Rate")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="pickup_order_rate"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Delivery Order Rate")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Delivery Order Rate")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="delivery_order_rate"
                        placeholder={t("Delivery Order Rate")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="delivery_order_rate"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  {/* new fields */}
                  {/* {values?.laundry_man_type === "truck_driver" && (
                    <Col span={8}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Pickup Order Rate from store to laundry")}
                          <span className="text-[red]">*</span>
                        </label>
                        
                        <Field
                          className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          type="text"
                          name="pickup_order_rate_from_store_to_laundry"
                          placeholder={t(
                            "Pickup Order Rate from store to laundryfsadfsdafasd"
                          )}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;
                            const keyValue = String.fromCharCode(keyCode);
                            const regex = /^[0-9]+$/;
                            if (!regex.test(keyValue)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="pickup_order_rate_from_store_to_laundry"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>
                  )} */}

                  {values?.laundry_man_type === "truck_driver" && (
                    <Col span={8}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Pickup Order Rate from laundry to Store")}
                          <span className="text-[red]">*</span>
                        </label>
                        {/* <label
                          for="floating_outlined"
                          className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                        >
                          {t("Pickup Order Rate from laundry to Store")}{" "}
                        </label> */}
                        <Field
                          // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                          className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          type="text"
                          name="pickup_order_rate_from_laundry_to_store"
                          placeholder={t(
                            "Pickup Order Rate from laundry to store"
                          )}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;
                            const keyValue = String.fromCharCode(keyCode);
                            const regex = /^[0-9]+$/;
                            if (!regex.test(keyValue)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="pickup_order_rate_from_laundry_to_store"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>
                  )}
                  {values?.laundry_man_type === "truck_driver" && (
                    <Col span={8}>
                      <div className="mb-3">
                        <label className="font-semibold">
                          {" "}
                          {t("Order Rate from Store to Laundry")}
                          <span className="text-[red]">*</span>
                        </label>
                        {/* <label
                          for="floating_outlined"
                          className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                        >
                          {t("Pickup Order Rate from laundry to Store")}{" "}
                        </label> */}
                        <Field
                          // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                          className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          type="text"
                          name="pickup_order_rate_from_store_to_laundry"
                          placeholder={t("Order Rate from Store to Laundry")}
                          onKeyPress={(event) => {
                            const keyCode = event.keyCode || event.which;
                            const keyValue = String.fromCharCode(keyCode);
                            const regex = /^[0-9]+$/;
                            if (!regex.test(keyValue)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="order_rate_from_store_to_laundry"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>
                  )}

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Pickup Order Rate from laundrybox")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Pickup Order Rate from laundrbox")}{" "}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="pickup_order_rate_from_laundrybox"
                        placeholder={t("Pickup Order Rate from laundrybox")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="pickup_order_rate_from_laundrybox"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  {/* new fields */}

                  {/* <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Dispatch Order Rate")}
                        <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="dispatch_order_rate"
                        placeholder={t("Dispatch Order Rate")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="dispatch_order_rate"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> */}

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Driving License Number")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Driving License Number")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="driving_license_number"
                        placeholder={t("Driving License Number")}
                      />
                      <ErrorMessage
                        name="driving_license_number"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Availability")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Availability")}{" "}
                      </label> */}
                      <Select
                        // className="mt-2 h-11 rounded-xl border bg-white p-3 text-sm outline-none"
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 py-2 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        name="days"
                        mode="multiple"
                        placeholder={t("Availability")}
                        value={selectedDays}
                        onChange={handleDaySelect}
                        style={{ width: "100%" }}
                      >
                        <Option value="Monday">{t("Monday")}</Option>
                        <Option value="Tuesday">{t("Tuesday")}</Option>
                        <Option value="Wednesday">{t("Wednesday")}</Option>
                        <Option value="Thursday">{t("Thursday")}</Option>
                        <Option value="Friday">{t("Friday")}</Option>
                        <Option value="Saturday">{t("Saturday")}</Option>
                        <Option value="Sunday">{t("Sunday")}</Option>
                      </Select>

                      {selectedDays?.map((day) => {
                        console.log(selectedTimes, "i am day");
                        return (
                          <div key={day} style={{ marginTop: "1rem" }}>
                            <label>{day}:</label>
                            <br />
                            <div className="flex w-full flex-row items-center justify-between gap-2">
                              <Datetime
                                dateFormat={false}
                                timeFormat="h:mm A"
                                onChange={(time) =>
                                  handleStartTimeSelect(day, time)
                                }
                                placeholder="Select time"
                                value={
                                  selectedTimes[day]?.start
                                    ? selectedTimes[day]?.start
                                    : "Start time"
                                }
                              />
                              <Datetime
                                dateFormat={false}
                                timeFormat="h:mm A"
                                onChange={(time) =>
                                  handleEndTimeSelect(day, time)
                                }
                                placeholder="Select time"
                                value={
                                  selectedTimes[day]?.end
                                    ? selectedTimes[day]?.end
                                    : "End time"
                                }
                              />
                            </div>

                            {/* <TimePicker
                            name={`startTime-${day}`}
                            placeholder="Select start time"
                            value={selectedTimes[day]?.start}
                            onChange={(time) => {
                              console.log("wow");handleStartTimeSelect(day,time)}}
                            format="h:mm A"
                            style={{ width: "45%", marginRight: "1rem" }}
                          /> */}

                            {/* <TimePicker
                              name={`endTime-${day}`}
                              placeholder="Select end time"
                              value={
                                selectedTimes[day]?.end
                                  ? moment(selectedTimes[day].end, "HH:mm")
                                  : null
                              }
                              onChange={(time) =>
                                handleEndTimeSelect(day, time)
                              }
                              format="h:mm A"
                              style={{ width: "45%" }}
                            /> */}
                          </div>
                        );
                      })}

                      <ErrorMessage
                        name="availability"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                {isSubmitting && Object.keys(errors).length > 0 && (
                  <div>
                    {Object.keys(errors).map((fieldName, index) => (
                      <div key={index}>{errors[fieldName]}</div>
                    ))}
                  </div>
                )}
                {/* Log isSubmitting and button disabled state */}
                {console.log("IsSubmitting:", isSubmitting)}
                {console.log("Button Disabled:", isSubmitting || errors)}
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Creating") + "..." : t("Create Driver")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateLaundryMan;
